/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useCallback } from "react";

type SkuKeys = { podcast_premium: string; firefly_pro: string };
type SkuT = (keys: SkuKeys, opts?: Record<string, unknown>) => string;

// I18n facade that picks between two translation keys. The
// podcast_sku_migration_enabled flag is now hardcoded on (the migration is
// complete), so this always resolves to the "Firefly Pro" variant.
// Pass the existing "Podcast Premium" key and the new "Firefly Pro" variant.
export const useSkuMigrationI18n = (): SkuT => {
  // PHONOS-4726 Hardcoded isFireflyPro to true for now. We will clean up later.
  const enabled = true;
  return useCallback<SkuT>(
    (keys, opts = {}) =>
      I18n.t(enabled ? keys.firefly_pro : keys.podcast_premium, opts),
    [enabled]
  );
};
